import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { Loading } from '@rd-web-markets/shared/dist/util';
import Modal from '@rd-web-markets/shared/dist/util/Modal';
import { UserService } from '@rd-web-markets/shared/dist/services/user.service';
import React, { useRef } from 'react';
import { useState, useEffect } from 'react';
import { Col, Form, Card, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Select from 'react-select';
import { ENGAGEMENT_TEAM_ROLES } from '../constants';
import ImmutableUnderReviewFormCheck from '@rd-web-markets/shared/dist/util/reviewEditControls/ImmutableUnderReviewFormCheck';
import engagementTeamService from '@rd-web-markets/shared/dist/services/claim_groups/engagement_team.service';
const CreateUserAccessModal = _ref => {
  let {
    show,
    title,
    onHide,
    onSubmit,
    claimGroup
  } = _ref;
  const [clientContact, setClientContact] = useState({
    id: null,
    roles: [],
    included_in_engagement_team: false
  });
  const [claimGroupAndCompanyTeam, setClaimGroupAndCompanyTeam] = engagementTeamService.useGetEngagementTeam({
    claimGroupId: claimGroup.id
  });
  const dispatch = useDispatch();
  const roles = ENGAGEMENT_TEAM_ROLES;
  const {
    t
  } = useTranslation();
  const handleAddRole = event => {
    const roles = clientContact.roles;
    if (event.target.checked) {
      roles.push(event.target.value);
      setClientContact({
        ...clientContact,
        roles: roles,
        included_in_engagement_team: event.target.value === 'client_sponsor' ? true : clientContact.included_in_engagement_team
      });
    } else {
      setClientContact({
        ...clientContact,
        roles: roles.filter(role => role !== event.target.value)
      });
    }
  };
  const handleChange = (value, fieldName) => {
    setClientContact({
      ...clientContact,
      [fieldName]: value
    });
  };
  const handleChangeIncludeEngagementTeam = event => {
    setClientContact({
      ...clientContact,
      included_in_engagement_team: event.target.checked
    });
  };
  const clientContactModalBody = () => {
    return /*#__PURE__*/React.createElement(Card, {
      className: "mt-3"
    }, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Table, {
      className: "table-bordered"
    }, /*#__PURE__*/React.createElement("tbody", {
      "data-testid": "clientContactModalBody"
    }, /*#__PURE__*/React.createElement("tr", {
      className: "text-primary app-fs-table-header"
    }, /*#__PURE__*/React.createElement("th", {
      className: "border-0 font-weight-normal",
      style: {
        width: '20%'
      }
    }, t('user')), /*#__PURE__*/React.createElement("th", {
      className: "border-0 font-weight-normal",
      style: {
        width: '20%'
      }
    }, t('role')), /*#__PURE__*/React.createElement("th", null, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormCheck, {
      value: clientContact.included_in_engagement_team,
      label: t('engagement_team'),
      checked: clientContact.included_in_engagement_team,
      name: "included_in_engagement_team",
      onChange: e => handleChangeIncludeEngagementTeam(e)
    }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Form.Control, {
      as: Select,
      onChange: e => handleChange(e.value, 'user_id'),
      options: claimGroupAndCompanyTeam.company_users_not_added_to_claim_group.map(u => {
        return {
          value: u.user_id,
          label: `${u.name} ${u.email}`
        };
      }),
      size: "md",
      className: "p-0 border-0",
      styles: {
        control: baseStyles => ({
          ...baseStyles,
          borderColor: '#80bbdc'
        })
      }
    })), /*#__PURE__*/React.createElement("td", {
      style: {
        width: '20%'
      }
    }, roles.map(role => {
      return /*#__PURE__*/React.createElement(Form.Check, {
        checked: clientContact.roles.includes(role.value),
        value: role.value,
        name: role.value,
        label: t(role.value),
        onChange: e => handleAddRole(e)
      });
    })))))));
  };
  if (!claimGroupAndCompanyTeam) return /*#__PURE__*/React.createElement(Loading, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    size: "xl",
    title: t(title),
    show: show,
    renderBody: () => clientContactModalBody(),
    onHide: onHide,
    onSubmit: () => onSubmit(clientContact)
  }));
};
export default CreateUserAccessModal;